import React from 'react';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
// Импортируем новые SVG-логотипы
import { ReactComponent as HubspotLogo } from './assets/companyLogos/HubspotLogo.svg';
import { ReactComponent as BuzzfeedLogo } from './assets/companyLogos/BuzzfeedLogo.svg';
import { ReactComponent as ForbesLogo } from './assets/companyLogos/ForbesLogo.svg';
import { ReactComponent as BusinessInsiderLogo } from './assets/companyLogos/BusinessInsiderLogo.svg';
import { ReactComponent as HarvardLogo } from './assets/companyLogos/HarvardLogo.svg';
import { ReactComponent as StanfordLogo } from './assets/companyLogos/StanfordLogo.svg'; 
import { ReactComponent as AbcLogo } from './assets/companyLogos/AbcLogo.svg';
import { ReactComponent as MichLogo } from './assets/companyLogos/MichLogo.svg';
import { ReactComponent as NbcLogo } from './assets/companyLogos/NbcLogo.svg';
import { ReactComponent as ReutersLogo } from './assets/companyLogos/ReutersLogo.svg';

export const MediaMentions: React.FC = () => {

    const { t } = useTranslation();
    
    const mediaLogos = [
        { Component: ForbesLogo, width: 180, height: 90 },
        { Component: BuzzfeedLogo, width: 210, height: 80 },
        { Component: HubspotLogo, width: 165, height: 100 },
        { Component: BusinessInsiderLogo, width: 180, height: 90 },
        { Component: HarvardLogo, width: 180, height: 90 },
        { Component: StanfordLogo, width: 180, height: 90 },
        { Component: AbcLogo, width: 180, height: 90 },
        { Component: MichLogo, width: 180, height: 90 },
        { Component: NbcLogo, width: 180, height: 90 },
        { Component: ReutersLogo, width: 180, height: 90 },
    
    ];

    const duplicatedLogos = [...mediaLogos, ...mediaLogos];

    return (
        <div className={`${styles.MediaMentions} app-container`}>
            <div className={styles.MediaMentions__textContainer}>
                <h2 className={styles.MediaMentions__title}>
                    {t('media.mentions.title')}
                </h2>
            </div>
            
            <div className={styles.logosContainer}>
                <div className={styles.logosTrack}>
                    {duplicatedLogos.map(({ Component, width, height }, index) => (
                        <Component
                            key={index}
                            className={styles.logoItem}
                            width={width}
                            height={height}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};